export class Holiday {
  id = '';
  name = '';
  date = '';
  code = '';
  isEdit = false;
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/models/holiday.ts